import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import styled from 'styled-components';

export const CropperContainer = styled.div`
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  &::after {
    background-image: repeating-linear-gradient(#fff 0 1px, transparent 1px 100%),
      repeating-linear-gradient(90deg, #fff 0 1px, transparent 1px 100%);
    /* Nudge the grid so that the top and left lines are not visible */
    background-position: -2px -2px;
    /* Size the grid so that extraneous grid lines don't appear to the right and bottom of the image */
    background-size: calc(33.34% + 2px) calc(33.34% + 2px);
    border-radius: 8px;
    border: 1px solid ${cbSemanticCssVars.borderPrimary};
    box-sizing: border-box;
    content: '';
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }
`;

export const ZoomControls = styled.div`
  bottom: 16px;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 16px;
  & > * + * {
    margin-block-start: 8px;
  }
`;
